var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landingDegraded",attrs:{"id":"app"}},[_c('LandingHeader'),_c('LandingBody'),_c('LandingFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }